import { Grid, styled } from "@mui/material";
import { memo } from "react";
import BuildingUnitFormIndexSection from "./BuildingUnitFormIndexSection";
import BuildingUnitFormOptionsSection from "./BuildingUnitFormOptionsSection";
import BuildingUnitFormRendersFieldUnit from "./BuildingUnitFormRendersFieldUnit";
import useFieldTable from "../../../../hooks/useBuiltTableField";

interface IBuildingUnitFormProps {}
const BuildingUnitForm = (props: IBuildingUnitFormProps) => {
  const fields = useFieldTable();
  const items = fields.filter(x => x.field !== "id" && x.field !== "opt");
  console.log(items);
  return (
    <ContentInfo container count={fields.length}>
      <BuildingUnitFormIndexSection />
      {items.map((x, i) => (
        <BuildingUnitFormRendersFieldUnit item={x} key={i} />
      ))}
      <BuildingUnitFormOptionsSection />
    </ContentInfo>
  );
};

export default memo(BuildingUnitForm);

const ContentInfo = styled(Grid)<{ count: number }>(({ theme, count }) => () => {
  const s = {
    width: "100%",
    display: "grid",
    borderBottom: `1px solid ${theme.palette.grey[300]}`
  };

  if (count == 12) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }
  if (count == 11) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }

  if (count == 8) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }

  if (count == 6) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }

  return s;
});
